import CreateChannelForm from './CreateChannelForm'

export default CreateChannelForm
